import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  BooleanField,
  IntegerField,
  TextField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Справочник валют.
 *
 * Описывает доступные валюты учёта: код ISO, человекочитаемое название,
 * число знаков после запятой и дополнительную информацию для интерфейса.
 */
export const AccountingCurrencySchema = Type.Object({
  ...SystemFields,

  code: StringField({
    title: 'Код валюты',
    minLength: 1,
    maxLength: 12,
    description: 'Уникальный символьный код валюты (обычно ISO 4217).',
    unique: true,
  }),

  name: StringField({
    title: 'Название валюты',
    minLength: 1,
    maxLength: 255,
    description: 'Полное человекочитаемое название валюты.',
  }),

  precision: IntegerField({
    title: 'Точность',
    minimum: 0,
    maximum: 8,
    default: 2,
    description: 'Количество знаков после запятой для денежных расчётов.',
  }),

  symbol: StringField({
    title: 'Символ',
    nullable: true,
    maxLength: 16,
    description: 'Короткий символ или знак валюты (₽, $, € и т.п.).',
  }),

  is_default: BooleanField({
    title: 'Базовая валюта',
    default: false,
    description: 'Флаг указывает, является ли валюта базовой для компании.',
  }),

  is_active: BooleanField({
    title: 'Активна',
    default: true,
    description: 'Неактивные валюты недоступны для выбора в документах.',
  }),

  description: TextField({
    title: 'Описание',
    nullable: true,
    description: 'Дополнительные комментарии или инструкции по использованию валюты.',
  }),
});

export type AccountingCurrency = Static<typeof AccountingCurrencySchema>;

export default defineSchema({
  moduleName,
  tableName: 'currencies',
  schema: AccountingCurrencySchema,
  additionalIndexes: [{ columns: ['code'], unique: true }, 'is_active'],
});
